import { ActionMessage } from 'lib/constraintsChecker/ActionMessage';
import { ActionMessageResponse } from 'lib/constraintsChecker/ActionMessageResponse';

export enum ActionConstraintType {
  Cancel = 'C',
  Warning = 'W',
  Modify = 'M',
  Info = 'I',
}

export class ActionConstraint {
  type: ActionConstraintType;
  message?: ActionMessage;
  change?: string;
  responses?: ActionMessageResponse[];
  proposeUndo: boolean;
  modal: boolean;
  image?: string;
  noOK: boolean;

  constructor(
    type: ActionConstraintType,
    message?: ActionMessage,
    change?: string,
    responses?: ActionMessageResponse[],
    proposeUndo = false,
    modal = false,
    image?: string,
    noOK = false,
  ) {
    this.type = type;
    this.message = message;
    this.change = change;
    this.responses = responses;
    this.proposeUndo = proposeUndo;
    this.modal = modal;
    this.image = image;
    this.noOK = noOK;
  }
}
